import { useEffect, useState } from "react";
import { callAPI } from "../../lib/common";
const initState = (type) => ({
    templates: [],
    type: type,
});
const useTemplateList = (type, category) => {
    const [templates, setTemplates] = useState(initState(type));
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        // Race condition hack:
        let active = true;
        setTemplates(initState(type));
        setLoading(true);
        let url = `/m/api/templates/${type}`;
        if (category) {
            url += `/categories/${category}`;
        }
        callAPI(url)
            .then((t) => {
            if (active) {
                setTemplates({
                    type: type,
                    templates: t,
                });
                setLoading(false);
            }
        })
            .catch((err) => console.log("Error", err));
        return () => {
            active = false;
        };
    }, [type, category]);
    return [templates, loading];
};
export default useTemplateList;
